import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { useGoogleAuth } from "../contexts/GoogleAuthContext";
import { Role, hasRequiredRole } from "../utils/roles";

interface PrivateRouteProps {
  children: any;
  roles: Role[];
}

export const PrivateRoute = ({ children, roles }: PrivateRouteProps) => {
  const { accessToken, userRoles } = useGoogleAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const performNavigation = async () => {
      if (!accessToken) {
        navigate("/login", { state: { from: location } });
        return;
      }
      if (!hasRequiredRole(userRoles, roles)) {
        navigate("/403");
      }
    };

    performNavigation();
  }, [navigate, roles, accessToken, userRoles, location]);

  return children;
};

export default PrivateRoute;
